/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { WindowRefService } from './window-ref';

const MSG_TYPE = 'NAVIGATE_TO_INSTRUMENT';

@Injectable({ providedIn: 'root' })
export class NavigationBridgeService {
  private readonly windowRef = inject(WindowRefService);

  navigateToInstrument(isin: string) {
    const win = this.windowRef.nativeWindow as any;
    if (!win) return;

    // Dual shape intentional: zero-frontend consumes `isin` at the top level (its listener
    // predates and never adopted MessageBridgeService's { type, payload } envelope), while
    // Finnet's ai-frame.js expects the standard envelope like every other message type and
    // otherwise logs "isin is missing or invalid" reading a non-existent `payload.isin`.
    // Sending both keeps each consumer working without knowing about the other's shape.
    const message = { type: MSG_TYPE, isin, payload: { isin } };

    // Bridge detection order mirrors MessageBridgeService.
    if (typeof win.AuthBridge?.postMessage === 'function') {
      // Zero Flutter WebView — expects a plain "TYPE:payload" string, not JSON.
      win.AuthBridge.postMessage(`${MSG_TYPE}:${isin}`);
    } else if (typeof win.webkit?.messageHandlers?.FinnetBridge?.postMessage === 'function') {
      // Finnet iOS WKWebView
      win.webkit.messageHandlers.FinnetBridge.postMessage(JSON.stringify(message));
    } else if (typeof win.AndroidBridge?.postMessage === 'function') {
      // Finnet Android WebView
      win.AndroidBridge.postMessage(JSON.stringify(message));
    } else if (win.parent && win.parent !== win) {
      // Web iframe (zero-frontend, finanzen.net) — postMessage accepts the raw object directly.
      win.parent.postMessage(message, '*');
    } else {
      console.warn('No bridge found for', MSG_TYPE);
    }
  }
}
